const { forEach } = require("@splidejs/splide/src/js/utils");

window.addEventListener("DOMContentLoaded", function () {
  
  // navbar hide/show
  let scrollNavigationTimeout;
  window.addEventListener("scroll", function () {
    const headerNavigation = document.querySelector(".page-header__navigation");
    const scrollPosition = window.scrollY;
    clearTimeout(scrollNavigationTimeout);

    scrollNavigationTimeout = setTimeout(() => {
      // Scrolling down
      if (scrollPosition > 200) {
        headerNavigation.classList.add("hidden-nav");
      } 
      else if (scrollPosition < 100) {
        headerNavigation.classList.remove("hidden-nav");
      }
    }, 200);
  });
  
  // append cards tooltip
  const naex_dl = document.querySelector("[data-name='naex_driving_licence_number']");
  const other_dl = document.querySelector("[data-name='other_driving_licence_number']");
  const air_dl = document.querySelector("[data-name='air_driving_licence_number']");
  
  const naex_dt= document.querySelector("[data-name='naex_digital_tachograph_card']");
  const other_dt = document.querySelector("[data-name='other_digital_tachograph_card']");
  const air_dt = document.querySelector("[data-name='air_digital_tachograph_card']");
  
  const other_dq = document.querySelector("[data-name='other_driver_qualification_card']");
  const air_dq = document.querySelector("[data-name='air_driver_qualification_card']");
  
  // Debug check for elements
  console.log('Found elements:', {
    naex_dl, other_dl, air_dl,
    naex_dt, other_dt, air_dt,
    other_dq, air_dq
  });

  const span = document.createElement('span');
  span.classList.add("tooltip-icon");
  span.textContent = "!";
  
  // Driver License
  if (naex_dl) {
    naex_dl.classList.add("-dl");
    const label = naex_dl.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  if (other_dl) {
    other_dl.classList.add("-dl");
    const label = other_dl.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  if (air_dl) {
    air_dl.classList.add("-dl");
    const label = air_dl.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  
  // Driver Tachograph
  if (naex_dt) {
    naex_dt.classList.add("-dt");
    const label = naex_dt.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  if (other_dt) {
    other_dt.classList.add("-dt");
    const label = other_dt.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  if (air_dt) {
    air_dt.classList.add("-dt");
    const label = air_dt.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  
  // Driver Qualification
  if (other_dq) {
    other_dq.classList.add("-dq");
    const label = other_dq.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  if (air_dq) {
    air_dq.classList.add("-dq");
    const label = air_dq.querySelector("label");
    if (label) label.appendChild(span.cloneNode(true));
  }
  
  const dl = document.querySelectorAll(".-dl");
  const divDL = document.createElement('div');
  divDL.classList.add("tooltip");
  const imgDL = document.createElement('img');
  imgDL.src = '/wp-content/themes/framework/public/images/preview-dl.jpg';
  divDL.appendChild(imgDL);
  
  dl.forEach(element => {
    element.appendChild(divDL.cloneNode(true));
  });
  
  const dt = document.querySelectorAll(".-dt");
  const divDT = document.createElement('div');
  divDT.classList.add("tooltip");
  const imgDT = document.createElement('img');
  imgDT.src = '/wp-content/themes/framework/public/images/preview-dt.jpg';
  divDT.appendChild(imgDT);
  
  dt.forEach(element => {
    element.appendChild(divDT.cloneNode(true));
  });
  
  const dq = document.querySelectorAll(".-dq");
  const divDQ = document.createElement('div');
  divDQ.classList.add("tooltip");
  const imgDQ = document.createElement('img');
  imgDQ.src = '/wp-content/themes/framework/public/images/preview-dq.jpg';
  divDQ.appendChild(imgDQ);
  
  dq.forEach(element => {
    element.appendChild(divDQ.cloneNode(true));
  });
  
  // Debug check for tooltips
  console.log('Found tooltips:', {
    dl: dl.length,
    dt: dt.length,
    dq: dq.length
  });
  
  const tooltipIcons = document.querySelectorAll(".tooltip-icon");
  console.log('Found tooltip icons:', tooltipIcons.length);
  
  tooltipIcons.forEach(icon => {
    icon.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent event bubbling
      event.preventDefault(); // Prevent default behavior
      
      console.log('Tooltip clicked');

      let parentElement = null;
      if (event.target.closest(".-dl")) {
        parentElement = event.target.closest(".-dl");
      }
      if (event.target.closest(".-dt")) {
        parentElement = event.target.closest(".-dt");
      }
      if (event.target.closest(".-dq")) {
        parentElement = event.target.closest(".-dq");
      }
      
      if (parentElement) {
        const tooltip = parentElement.querySelector(".tooltip");
        if (tooltip) {
          const newDisplay = tooltip.style.display === "block" ? "none" : "block";
          console.log('Toggling tooltip display to:', newDisplay);
          tooltip.style.display = newDisplay;
        } else {
          console.log('No tooltip found in parent');
        }
      } else {
        console.log('No parent element found');
      }
    });
  });
  
  const acfLabel = document.querySelectorAll(".acf-label");
  acfLabel.forEach(element => {
    element.addEventListener('click', function(event) {
      // Only prevent default if clicking the label itself and not a child link or tooltip
      if (!event.target.closest('a') && !event.target.closest('.tooltip-icon')) {
        event.preventDefault();
      }
    });
  });

});
